import { render, staticRenderFns } from "./UserAccountsView.vue?vue&type=template&id=46384614"
import script from "./UserAccountsView.vue?vue&type=script&lang=js"
export * from "./UserAccountsView.vue?vue&type=script&lang=js"
import style0 from "./UserAccountsView.vue?vue&type=style&index=0&id=46384614&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports